import React from 'react';
import _ from 'lodash';
import L from 'react-loadable';

import Loading from '../components/Loading';
import Base from '../components/BaseComponent';

const Loadable = opts => L({
  loading: Loading,
  delay: 500,
  ...opts,
});

const Login = Loadable({ loader: () => import(/* webpackChunkName: "login" */ './Login') });
const Main = Loadable({ loader: () => import(/* webpackChunkName: "main" */ './Main') });
const MyAccount = Loadable({ loader: () => import(/* webpackChunkName: "my-account" */ './MyAccount') });
const Enterprise = Loadable({ loader: () => import(/* webpackChunkName: "enterprise" */ './Enterprise') });
const Display = Loadable({ loader: () => import(/* webpackChunkName: "display" */ './Display')});
const Label = Loadable({ loader: () => import(/* webpackChunkName: "label" */ './Label')});
const Test = Loadable({ loader: () => import(/* webpackChunkName: "test" */ './Test')});
const User = Loadable({ loader: () => import(/* webpackChunkName: "user" */ './User')});
const JejuSnap = Loadable({ loader: () => import(/* webpackChunkName: "jejusnap" */ './Product/Jeju')});
const MainSnap = Loadable({ loader: () => import(/* webpackChunkName: "mainsnap" */ './Product/Main')});
const SimpleStudio = Loadable({ loader: () => import(/* webpackChunkName: "simple" */ './Product/Simple')});
const Dme = Loadable({ loader: () => import(/* webpackChunkName: "dme" */ './Product/Dme')});
const Dvd = Loadable({ loader: () => import(/* webpackChunkName: "dvd" */ './Product/Dvd')});
const WeddingHall = Loadable({ loader: () => import(/* webpackChunkName: "weddinghall" */ './WeddingHall')});
const Payment = Loadable({ loader: () => import(/* webpackChunkName: "payment" */ './Payment/List')});
const PaymentAdd = Loadable({ loader: () => import(/* webpackChunkName: "products-add" */ './Payment/Add') });

const Exhibition = Loadable({ loader: () => import(/* webpackChunkName: "exhibition" */ './Exhibition')});
const ProxyInquiry = Loadable({ loader: () => import(/*webpackChunkName: "proxy-inquiry" */ './ProxyInquiry')})

const ProxyRule = Loadable({ loader: () => import(/*webpackChunkName: "proxy-reservation "*/ './ProxyRule')})

const Switch = ({ userInfo, userAuthority }) => {
  const { pathname } = window.location;

  switch (pathname) {
    case '/':
    case '/login': // 로그인
      return <Login />;

     // 메인
    case '/admin/main':
    case '/main':
      return <Main />;

    // 업체 관리
    case '/enterprise':
        return <Enterprise />;

    //업체 상품 전시 관리
    case '/display':
        return <Display />;

    //업체 상품 라벨 관리
    case '/label':
      return <Label />;

    //상품정보관리 - 제주스냅관리
    case '/jejusnap':
      return <JejuSnap />;

    //상품정보관리 - 본식스냅관리
    case '/mainsnap':
      return <MainSnap />;

    //상품정보관리 - 심플스튜디오 관리
    case '/simple':
      return <SimpleStudio />;

    case '/dme':
    //상품정보관리 - 드레스/메이크업 관리
      return <Dme />;

    case '/dvd':
    //상품정보관리 - 본식DVD 관리
      return <Dvd />;

    //결제 관리
    case '/payment':
      return <Payment/>

    case '/payment/add':
      return <PaymentAdd/>

    //유저 정보 관리
    case '/user':
      return <User />;

    //웨딩홀 관리
    case '/weddinghall':
      return <WeddingHall />;

    //기획전 관리
    case '/plan':
      return <Exhibition />;

    //문의대행 관리
    case '/proxy':
      return <ProxyInquiry />;

    //문의대행 담당자 관리
    case '/proxy-rule':
      return <ProxyRule />;

    //이벤트 관리
    case '/events':
      return null;
//        return <SafePhone />;

    //배너 관리
    case '/banners':
      return null;
    // 마이페이지
    case '/my-account':
      return <MyAccount userInfo={userInfo} />;

    // 테스트
    case '/test':
//      return null;
      return <Test />;

    default:
      // return (window.location.href = '/error/404');
  }
};

export default Base(Switch);



// WEBPACK FOOTER //
// ./client/Admin/switch.js